var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.456,
    height: 17.914,
    viewBox: "0 0 13.456 17.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15553",
    "data-name": "Path 15553",
    d: "M167.448,28a6.732,6.732,0,0,0-6.728,6.728c0,5.514,6.728,11.186,6.728,11.186s6.728-5.673,6.728-11.186A6.732,6.732,0,0,0,167.448,28Zm0,9.912a3.185,3.185,0,1,1,3.185-3.185A3.194,3.194,0,0,1,167.448,37.912Z",
    transform: "translate(-160.72 -28)",
    fill: "#1d2432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ff3a28886514e987c061320c94f21fa9.svg";
export { ForwardRef as ReactComponent };